
export class Utilities {

  public static GetContentType(fileType: string):string {
    var contentType = "";
    fileType = fileType.replace(".", "");
    switch (fileType) {
      case "pdf":
        contentType = "application/pdf";
        break;
      case "png":
        contentType = "image/png";
        break;
      case "jpg":
      case "jpeg":
      case "jpe":
        contentType = "image/jpeg";
        break;
      case "bmp":
        contentType = "image/bmp";
        break;
      case "tiff":
      case "tif":
        contentType = "image/tiff";
        break;
      case "svg":
        contentType = "image/svg+xml";
        break;
      case "mp2":
      case "mpa":
      case "mpe":
      case "mpeg":
      case "mpg":
      case "mpv2":
        contentType = "video/mpeg";
        break;
      case "mp3":
        contentType = "audio/mpeg";
      case "mp4":
        contentType = "video/mp4";
        break;

    }

    return contentType;
  }

  public static GenerateGuidString():string {
    let d = new Date().getTime();
    const guid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return guid;
  }
}
